import { io } from 'socket.io-client';

const socket = io("https://api.trippin.icu");
//const socket = io("http://localhost:5002");

export const connectSocket = (userId) => {
  socket.emit('register', userId);

  socket.on('notification', (notification) => {
    console.log('New notification:', notification);
  });

  return socket;
};

export default socket;
